import React from "react";
import { publicUrl } from "@/Helpers/general";
import {Link} from "react-router-dom";
import LoginButton from "@/Components/Auth0/LoginButton";

const LoginForm = () => {

    return (
        <>
            <div className="public-form login-form">

                <div className="text-center mb-4">
                    By clicking <span className="font-semibold">Login</span> you agree that you have read and accepted the <Link className="fake-link" to={publicUrl('terms-of-use')}>Terms of Use</Link>
                </div>

                <div>
                    <LoginButton/>
                </div>
            </div>
        </>
    );
};

export default LoginForm;
